import {RichTextEditor, MenuButtonBold, MenuButtonItalic, MenuControlsContainer, MenuDivider, MenuSelectHeading} from "mui-tiptap";
import FormControlLabel from '@mui/material/FormControlLabel';
import CloseIcon from '@mui/icons-material/Close';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import TextField from '@mui/material/TextField';
import Checkbox from '@mui/material/Checkbox';
import StarterKit from "@tiptap/starter-kit";
import {useTranslation} from "react-i18next";
import Toolbar from '@mui/material/Toolbar';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import AppBar from '@mui/material/AppBar';
import Grid from '@mui/material/Grid';
import React, {useRef} from 'react';
import {observer} from 'mobx-react';
import {useGlobalStorage} from './mobx/GlobalStorage.js';
import {COMM_OK} from './WsR2.js';

let saving = false;

const Trip = observer((props) => {
	const {isOpen, handleClose} = props;
	const gStorage = useGlobalStorage();
	const {t} = useTranslation('obs');
	const ref = useRef(null);

	function tripRxWs(status, msg) {
		saving = 0;

		if (status !== COMM_OK) {
			alert('Trip Rx timeout!');
			return -1;
		}

		if (msg.cmd === 'trip') {
			if (msg.op === 'save') {
				if (msg.result === 'OK') {
					handleClose(true);
				} else {
					alert('Trip save failed!');
				}
			} else if (msg.op === 'del') {
				if (msg.result === 'OK') {
					handleClose(true);
				} else {
					console.error('tripRxws: delete failed:', msg);
					alert('Trip delete failed!');
				}
			} else {
				console.error('tripRxWs: unknown operation:', msg.op);
			}
		} else {
			console.error('settingsRxWs: unknown cmd', msg.cmd);
		}
	}

	function nameChange(e) {
		if (!gStorage.conn.online)
			return;

		gStorage.trips.setTrip({...gStorage.trips.trip, name: e.target.value});
		gStorage.trips.setChanged(true);
	}

	function publicChange(e, value) {
		if (!gStorage.conn.online)
			return;

		gStorage.trips.setTrip({...gStorage.trips.trip, public_trip: value ? 1 : 0});
		gStorage.trips.setChanged(true);
	}

	function activeChange(e, value) {
		if (!gStorage.conn.online)
			return;

		gStorage.trips.setTrip({...gStorage.trips.trip, active: value ? 1 : 0});
		gStorage.trips.setChanged(true);
	}

	function allRepChanged(e, value) {
		if (!gStorage.conn.online)
			return;

		gStorage.trips.setTrip({...gStorage.trips.trip, all_reported: value ? 1 : 0});
		gStorage.trips.setChanged(true);
	}

	function onDescChange(editorState) {
//		console.log('descChange', editorState, editorState._immutable.lastChangeType);
		gStorage.trips.setChanged(true);
	}

	function saveDesc(data) {
		gStorage.trips.setTrip({...gStorage.trips.trip, description: data});
// 		console.log('saveDesc', gStorage.trips.trip);

		let msg = {
			sess_id: gStorage.conn.sess_id,
			cmd: 'trip',
			op: 'save',
			data: {
				trip: gStorage.trips.trip,
			}
		};

		saving = 1;
		gStorage.conn.ws.send(msg, tripRxWs);
	}

	function saveTrip() {
		saveDesc(JSON.stringify(ref.current.editor.getJSON()));
	}

	function delTrip() {
// 		console.log('delTrip');

		let msg = {
			sess_id: gStorage.conn.sess_id,
			cmd: 'trip',
			op: 'del',
			data: {
				trip: gStorage.trips.trip,
			}
		};

		saving = 1;
		gStorage.conn.ws.send(msg, tripRxWs);
	}

	return (
        	<Dialog onClose={() => handleClose(false)} aria-labelledby="trip-dialog" open={isOpen ? true : false} PaperProps={{sx: {margin: 0, padding: 0}}} >
			<Grid container direction="row" justifyContent="center" alignItems="center" spacing={0} style={{width:308}}>
				<AppBar position="sticky">
					<Toolbar variant="dense">
						<Typography variant="h6" style={{flexGrow: 1, textAlign: 'center'}}>{t('trips.trip')}</Typography>
						<IconButton edge="start" color="inherit" onClick={() => handleClose(false)} aria-label="close">
							<CloseIcon />
						</IconButton>
					</Toolbar>
				</AppBar>
				<Grid size={{xs: 12}} align={'center'}>
					<TextField 
						label={t('common.name')}
						variant="outlined"
						value={gStorage.trips.trip.name}
						onChange={nameChange}
						size="small"
						style={{width: 300, margin: 4}} 
					/>
				</Grid>
				<Grid size={{xs: 12}} align={'left'}>
					<RichTextEditor sx={{m:1}}
						ref={ref}
						extensions={[StarterKit]}
						content={gStorage.trips.trip.description}
						onUpdate={onDescChange}
						renderControls={() => (
							<MenuControlsContainer>
								<MenuSelectHeading />
								<MenuDivider />
								<MenuButtonBold />
								<MenuButtonItalic />
							</MenuControlsContainer>
						)}
					/>
				</Grid>

				<Grid size={{xs: 12}} align={'center'}>
					<FormControlLabel
						label={t('trips.public')}
						labelPlacement="start"
						checked={!!gStorage.trips.trip.public_trip}
						onChange={publicChange}
						control={<Checkbox color="primary" />}
						style={{margin: 4}}
					/>
				</Grid>
				<Grid size={{xs: 12}} align={'center'}>
					<FormControlLabel
						label={t('trips.active')}
						labelPlacement="start"
						checked={!!gStorage.trips.trip.active}
						onChange={activeChange}
						control={<Checkbox color="primary" />}
						style={{margin: 4}}
					/>
				</Grid>
				<Grid size={{xs: 12}} align={'center'}>
					<FormControlLabel
						label={t('trips.all_reported')}
						labelPlacement="start"
						checked={!!gStorage.trips.trip.all_reported}
						onChange={allRepChanged}
						control={<Checkbox color="primary" />}
						style={{margin: 4}}
					/>
				</Grid>
				<Grid size={{xs: 12}} align={'center'}>
					<div>
						<Button 
							variant="contained" 
							color="primary" 
							size="small" 
							style={{width:143, margin: 4}} 
							disabled={!gStorage.conn.online || gStorage.trips.trip.id === undefined || gStorage.trips.trip.id === null || gStorage.trips.trip.user_id !== gStorage.conn.user.id || !gStorage.trips.changed || saving > 0}
							onClick={saveTrip}>
								{t('add.save')}
						</Button>
						<Button 
							variant="contained" 
							color="primary" 
							size="small" 
							style={{width:143, margin: 4}} 
							disabled={!gStorage.conn.online || !gStorage.trips.trip.id || gStorage.trips.trip.id === 0 || gStorage.trips.trip.user_id !== gStorage.conn.user.id || saving > 0}
							onClick={delTrip}>
								{t('add.del')}
						</Button>
					</div>
				</Grid>
			</Grid>
		</Dialog>
	);
});

export default Trip;
